import React from "react";

export const SolicitudesCreditoFacturadasHeader = ({
  titulo,
  cantidad,
  indicador,
  texto,
  porcentaje,
  className,
  onClick,
  activo = false,
}) => {
  const containerClassName =
    className === undefined
      ? "solicitud-credito-facturada-container-resumen-item"
      : className;
  return (
    <div className={containerClassName} onClick={onClick}>
      <div
        className={`${"solicitud-credito-facturada-container-resumen-item-box"} ${
          activo === false
            ? "solicitud-credito-facturada-container-resumen-item-box-green"
            : "solicitud-credito-facturada-container-resumen-item-box-yellow"
        } `}
      >
        <div className="solicitud-credito-facturada-container-resumen-title">
          {titulo}
        </div>
        <div className="solicitud-credito-facturada-container-resumen-valor">
          {cantidad}
        </div>
        <div className="solicitud-credito-facturada-container-resumen-porcentaje">
          {porcentaje}
        </div>
      </div>
    </div>
  );
};
